import { ThemeEvents } from '@theme/events';
import { morph } from '@theme/morph';

class ReleaseGate extends HTMLElement {
  connectedCallback() {
    const closestSection = this.closest('.shopify-section, dialog');
    closestSection?.addEventListener(ThemeEvents.variantUpdate, this.updateGate);
  }

  disconnectedCallback() {
    const closestSection = this.closest('.shopify-section, dialog');
    closestSection?.removeEventListener(ThemeEvents.variantUpdate, this.updateGate);
  }

  updateGate = (event) => {
    if (event.detail.data.newProduct) {
      this.dataset.productId = event.detail.data.newProduct.id;
    } else if (event.target instanceof HTMLElement && event.target.dataset.productId !== this.dataset.productId) {
      return;
    }

    const newGate = event.detail.data.html.querySelector('release-gate');

    if (!newGate) return;

    morph(this, newGate, { childrenOnly: true });
  };
}

if (!customElements.get('release-gate')) {
  customElements.define('release-gate', ReleaseGate);
}
